module.exports = __webpack_public_path__ + "static/media/luke.418ee567.jpg";